module.exports = __webpack_public_path__ + "img/t2-teal.ec5d8938.png";